import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LicenseStorage } from '@portal-core/license-storage/models/license-storage.model';
import { LicenseStorageService } from '@portal-core/license-storage/services/license-storage.service';
import { LicenseUser } from '@portal-core/license-users/models/license-user.model';
import { LicenseContactSalesDialogComponent } from '@portal-core/licenses/components/license-contact-sales-dialog/license-contact-sales-dialog.component';
import { LicenseType } from '@portal-core/licenses/enums/license-type.enum';
import { License } from '@portal-core/licenses/models/license.model';
import { AutoUnsubscribe } from '@portal-core/util/auto-unsubscribe.decorator';
import { Observable } from 'rxjs';

@Component({
  selector: 'mc-license-subscription',
  templateUrl: './license-subscription.component.html',
  styleUrls: ['./license-subscription.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
@AutoUnsubscribe()
export class LicenseSubscriptionComponent implements OnChanges {
  @Input() license: License;
  @Input() licenseUser: LicenseUser;

  licenseStorage$: Observable<LicenseStorage>;

  constructor(
    private licenseStorageService: LicenseStorageService,
    private dialog: MatDialog,
  ) { }

  get isTrial(): boolean {
    return this.license?.LicenseType === LicenseType.Trial;
  }

  // wait for license to be loaded
  ngOnChanges(changes: SimpleChanges) {
    if (changes.license) {
      if (this.license) {
        // create an observable for the license storage
        this.licenseStorage$ = this.licenseStorageService.getItemById$(this.license.Id, { forceApiRequest: true });
      }
      else {
        this.licenseStorage$ = null;
      }
    }
  }

  openContactSalesDialog() {
    this.dialog.open(LicenseContactSalesDialogComponent, {
      ...LicenseContactSalesDialogComponent.DialogConfig,
      data: {
        license: this.license,
        licenseUser: this.licenseUser
      }
    });
  }
}
